import NonMobileAside from '@/components/appraisal/non-mobile-aside.tsx';
import NonMobileHeader from '@/components/appraisal/non-mobile-header.tsx';
import NonMobileMain from '@/components/appraisal/non-mobile-main.tsx';
import { PageWithAsideLayout } from '@/components/client-layouts/page-with-aside-layout.tsx';
import FullscreenMessage from '@/components/ui/layout/fullscreen-message.tsx';
import LayoutBox1024 from '@/components/ui/layout/layout-1024-box.tsx';
import useAppraisalId from '@/hooks/use-appraisal-id.ts';
import { appraisalStoreV2 } from '@/models/stores/appraisals-v2.ts';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react';

const AppraisalPage = observer(() => {
  const { appraisalId } = useAppraisalId();
  const appraisal = appraisalStoreV2.getById(appraisalId);

  if (!appraisal) {
    return (
      <FullscreenMessage>
        <div className="text-2xl">No Appraisal Found</div>
      </FullscreenMessage>
    );
  }

  return (
    <div className="h-full">
      <PageWithAsideLayout
        key={`appraisal-page-${appraisalId}`}
        mobile={{ header: null, subheader: null, aside: null, main: null }}
        nonMobile={{
          header: <NonMobileHeader appraisal={appraisal} />,
          aside: <NonMobileAside />,
          main: (
            <LayoutBox1024>
              <NonMobileMain appraisal={appraisal} />
            </LayoutBox1024>
          ),
        }}
      />
    </div>
  );
});

export const Route = createFileRoute(
  '/(authenticated)/appraisals/$appraisalId/',
)({
  component: AppraisalPage,
});
